import React from 'react';
import { Helmet } from 'react-helmet';
import Navigation from 'Components/Navigation';
import { registerAnalyticsPayload } from '@brighterion/utils/insights';
import { useAppStore } from 'Store';
import { Banner } from '@brighterionai/br-ui';
import styles from './RootElement.css';

type RootElementProps = React.PropsWithChildren<{
    children: React.ReactNode;
    options: { isMastercardConnectUser: boolean };
}>;

const RootElement = ({ children, options: { isMastercardConnectUser } }: RootElementProps): React.ReactElement => {
    const user = useAppStore.use.userDetails?.()!;
    const { tenantKey } = user;

    React.useEffect(() => {
        registerAnalyticsPayload(user, 'wls');
    }, [tenantKey]);

    return (
        <>
            <Helmet htmlAttributes={{ lang: 'en' }} titleTemplate='%s - Mastercard' defaultTitle='Watchlist Screening'>
                <meta name='description' content='A Mastercard app' />
            </Helmet>
            <Banner />
            <header id='header' role='banner' className={styles.header}>
                {/**
                 * If user is using MC Connect initialize Connect Sidekick.
                 * Sidekick will render the <connect-header /> and <connect-footer />
                 */}
                {isMastercardConnectUser && <connect-header max-width={10000} />}
                <Navigation options={{ isMastercardConnectUser }} />
            </header>

            {children}
            {isMastercardConnectUser && <connect-footer max-width={10000} role='contentinfo' />}
        </>
    );
};

export default RootElement;
